import React, {Component} from 'react';
import moment from 'moment';
import {Form, Input, Cascader, Button, message} from 'antd';
import {Redirect} from 'react-router';
import {adData} from '../../../utils/area';
import utils from '../../../utils/common';
import './generateOrder.less';


class GenerateOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {}, // 商品信息
      consignee: {}, // 收货人信息
      redirect: false,
      creating: false, // 是否正在创建订单
    };
  }

  componentWillMount() {
    if (window.common.loginOut(this)) {
      const consignee = JSON.parse(window.localStorage.getItem('orderInfo'));
      this.setState({info: this.props.location.state.info, consignee});
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  // 创建订单
  handleSubmit = (e) => {
    if (this.state.creating) return;
    this.setState({creating: true});
    const info = this.state.info;
    let random = '';
    let hasInfo = false;
    let orderInfo = {
      province: '',
      city: '',
      area: '',
      address: '',
      mobile: '',
      receiver: '',
      post_code: '',
    };
    while (random.length < 10) {
      random += `${Math.floor(Math.random() * 10)}`;
    }
    const price = (info.count * Number(info.price)).toFixed(2);
    const goods = [{
      goods_id: info.id, goods_qty: info.count, total_amt: price, type: 1
    }];
    info.type === 'setMeal' ? goods[0].type = 2 : null;
    let params = {
      order_no: `${moment().format('YYYYMMDDHHmmssSSS')}${random}`,
      total_amt: price,
      real_amt: (info.count * Number(info.discount).toFixed(2)),
      goods: JSON.stringify(goods),
    };
    if (info.is_post === 0 && e && e.preventDefault) {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err) {
          window.localStorage.setItem('orderInfo', JSON.stringify(values));
          orderInfo = {
            province: values.residence[0],
            city: values.residence[1],
            area: values.residence[2],
            address: values.address,
            mobile: values.mobile,
            receiver: values.consignee,
            post_code: values.postalCode,
          };
          hasInfo = true;
        }
      });
    }
    Object.assign(params, orderInfo);
    params = utils.dealElement(params);
    if (info.is_post === 0 && hasInfo || info.is_post !== 0) {
      window.api('order.createorder', params).then(res => {
        const data = {
          order_no: res.order_no,
          real_amt: res.real_amt,
          total_amt: res.total_amt,
          address: res.province ? `${res.province} ${res.city} ${res.area} ${res.address}` : null,
          goods_name: info.name,
          type: info.type === 'setMeal' ? '2' : '1'
        };
        this.setState({creating: false});
        this.props.history.push('/cashier', {info: data});
      }).catch((error) => {
        this.setState({creating: false});
        error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
        message.error(error.service_error_message);
      });
    }
  }

  render() {
    if (this.state.redirect) {
      return (<Redirect to="/login" />);
    }
    const {info, consignee} = this.state;
    const {getFieldDecorator} = this.props.form;
    return (
      <div id="generateOrder">
        <div className="content">
          <div className="page-title">确认订单信息</div>
          <div className="goods">
            <img src={info.img} />
            <div className="goods-info">
              <h2>{info.name}</h2>
              <p className="price">￥{info.discount} <span> × {info.count}</span></p>
            </div>
            <div className="price"><em>合计：￥</em><b>{(info.count * Number(info.discount)).toFixed(2)}</b></div>
          </div>
          {
            info.is_post === 0 ? (
              <div>
                <div className="page-title">填写收货人信息</div>
                <div className="bottom">
                  <Form onSubmit={this.handleSubmit} className="form" name="form">
                    <Form.Item
                      label="所在地区"
                    >
                      {getFieldDecorator(
                        'residence',
                        {
                          initialValue: consignee ? consignee.residence : '',
                          rules: [{type: 'array', required: true, message: '请选择所在地区'}],
                        }
                      )(<Cascader options={adData} placeholder="请选择所在地区" />)
                      }
                    </Form.Item>
                    <Form.Item
                      label="收货人"
                    >
                      {getFieldDecorator(
                        'consignee',
                        {
                          initialValue: consignee ? consignee.consignee : '',
                          rules: [{required: true, message: '请输入收货人'}]
                        }
                      )(<Input placeholder="请输入收货人" />)
                      }
                    </Form.Item>
                    <Form.Item
                      label="详细地址"
                    >
                      {getFieldDecorator(
                        'address',
                        {
                          initialValue: consignee ? consignee.address : '',
                          rules: [{required: true, message: '请输入详细地址'}]
                        }
                      )(<Input placeholder="请输入详细地址" />)
                      }
                    </Form.Item>
                    <Form.Item
                      label="手机号码"
                    >
                      {getFieldDecorator(
                        'mobile',
                        {
                          initialValue: consignee ? consignee.mobile : '',
                          rules: [
                            {required: true, message: '请输入手机号码'},
                            {pattern: /^^1(3|4|5|7|8|9)\d{9}$/, message: '请输入正确的手机号码'}
                          ]
                        }
                      )(<Input placeholder="请输入手机号码" />)
                      }
                    </Form.Item>
                    <Form.Item
                      label="邮政编码"
                    >
                      {getFieldDecorator(
                        'postalCode',
                        {
                          initialValue: consignee ? consignee.postalCode : '',
                          rules: [
                            {required: true, message: '请输入邮政编码'},
                            {pattern: /^[0-9]{6}$/, message: '邮政编码格式有误'}
                          ]
                        }
                      )(<Input placeholder="请输入邮编" />)
                      }
                    </Form.Item>
                    <Form.Item className="submitButton">
                      <Button
                        type="primary"
                        size="large"
                        htmlType="submit"
                        loading={this.state.creating}
                      >
                        提交订单
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            ) : (
              <div className="submit">
                <Button
                  type="primary"
                  size="large"
                  onClick={this.handleSubmit}
                  loading={this.state.creating}
                >
                  提交订单
                </Button>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

export default Form.create()(GenerateOrder);



// WEBPACK FOOTER //
// ./src/containers/frontEnd/generateOrder/generateOrder.jsx